import React, { Component } from "react";
import s from "./styles.scss";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { Inputs, Buttons, formConfig } from "./ReporteContactCenter.form";
import { MemoTable } from "./ReporteContactCenter.table";
import { ReporteContactCenterStore } from "../../../containers/comisionesContactCenter/reporte/ReporteContactCenter.store";
import { ReporteContactCenterDispatcher } from "../../../containers/comisionesContactCenter/reporte/ReporteContactCenter.dispatcher";
import {
  errorNotification,
  successNotification
} from "../../../../utils/notifications";
import { Styled } from "../../../../toolkit/decorators/Artifact";
import { downloadCsvComisiones } from "../../../actions/comisionContactCenter";

interface Props
  extends ReporteContactCenterStore,
    ReporteContactCenterDispatcher {}

interface State {
  periodoSeleccionado: string;
  descargando: boolean;
}

@Styled(s)
export default class ReporteContactCenterComponent extends Component<
  Props,
  State
> {
  state = {
    periodoSeleccionado: "",
    descargando: false
  };

  submit = async (values: any) => {
    const anio = values.anio || new Date().getFullYear();
    const mes = values.mes.toString().padStart(2, "0");
    const periodo = `${anio}-${mes}-01`;

    this.setState({ periodoSeleccionado: periodo });

    const preview = await this.props.getConsultarComisiones(periodo);

    if (!preview.fulfilled) {
      errorNotification(
        preview.gettingComisionContactCenterError ||
          "Error al consultar las comisiones"
      );
    }
  };

  onDownloadCsv = () => {
    const { periodoSeleccionado } = this.state;

    if (!periodoSeleccionado) {
      errorNotification("Debe consultar un periodo antes de descargar");
      return;
    }

    this.setState({ descargando: true });

    downloadCsvComisiones(periodoSeleccionado, (error: any) => {
      this.setState({ descargando: false });
      if (!error) {
        successNotification("Reporte descargado exitosamente");
      }
    });
  };

  render() {
    const {
      comisionContactCenterConsulta,
      gettingComisionContactCenter
    } = this.props;
    const { descargando } = this.state;

    return (
      <div className="container">
        <div className="row mt-3">
          <div className="col-12">
            <FormBuilder<Inputs, Buttons>
              config={formConfig}
              submit={this.submit}
              processing={gettingComisionContactCenter}
            />
          </div>
        </div>

        {comisionContactCenterConsulta && (
          <div className="row mt-4">
            <div className="col-12">
              <MemoTable
                data={comisionContactCenterConsulta}
                loading={gettingComisionContactCenter}
                onDownloadCsv={this.onDownloadCsv}
                descargando={descargando}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
